import withDatas from '../withDatas'

import defaultStyles from './styles'

const withDatasList = withDatas( defaultStyles ) ;

export default withDatasList ;
